import { configureStore } from '@reduxjs/toolkit';
import pokemonReducer from './pokemonSlice';
import themeReducer from './themeSlice';
import authReducer from './authSlice';
import userDataReducer from './userDataSlice';

export const store = configureStore({
  reducer: {
    pokemon: pokemonReducer,
    theme: themeReducer,
    auth: authReducer,
    userData: userDataReducer,
  },
});

export default store; 